var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfigFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 344C501.3 344 512 354.7 512 368C512 381.3 501.3 392 488 392H156.3C146.1 424.5 115.8 448 80 448C35.82 448 0 412.2 0 368C0 323.8 35.82 288 80 288C115.8 288 146.1 311.5 156.3 344H488ZM48 368C48 385.7 62.33 400 80 400C97.67 400 112 385.7 112 368C112 350.3 97.67 336 80 336C62.33 336 48 350.3 48 368ZM355.7 120C365.9 87.54 396.2 64 432 64C476.2 64 512 99.82 512 144C512 188.2 476.2 224 432 224C396.2 224 365.9 200.5 355.7 168H24C10.75 168 0 157.3 0 144C0 130.7 10.75 120 24 120H355.7ZM432 176C449.7 176 464 161.7 464 144C464 126.3 449.7 112 432 112C414.3 112 400 126.3 400 144C400 161.7 414.3 176 432 176Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigFilter);
export default __webpack_public_path__ + "static/media/configFilter.82e6c37e9754ee03b645ac9be837c1f5.svg";
export { ForwardRef as ReactComponent };